import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeToast } from '../store/slices/toastSlice';
import { useBrand } from '../context/BrandContext';

const NotificationToast = ({ toast }) => {
  const dispatch = useDispatch();
  const { assets } = useBrand();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(removeToast(toast.id));
    }, toast.duration || 6000);

    return () => clearTimeout(timer);
  }, [dispatch, toast.duration, toast.id]);

  return (
    <div className={`notification-toast ${toast.type || 'notification'}`} role="status">
      <div className="notification-toast-icon">
        <img src={assets.markUrl} alt="" aria-hidden="true" />
      </div>
      <div className="notification-toast-body">
        <div className="notification-toast-title">{toast.title || 'Notification'}</div>
        {toast.message && <div className="notification-toast-message">{toast.message}</div>}
        {toast.refNo && <div className="notification-toast-ref">{toast.refNo}</div>}
      </div>
      <button
        type="button"
        className="notification-toast-close"
        onClick={() => dispatch(removeToast(toast.id))}
        title="Dismiss notification"
        aria-label="Dismiss notification"
      >
        <i className="bi bi-x" aria-hidden="true"></i>
      </button>
    </div>
  );
};

const NotificationToasts = () => {
  const toasts = useSelector((state) => state.toasts.items);

  if (!toasts.length) return null;

  return (
    <div className="notification-toast-stack" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <NotificationToast key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default NotificationToasts;
